import React, {Component} from 'react'
import FontAwesome from 'react-fontawesome'
const colors = {
  mint: '#16a085',
  red: '#ea8557',
  blue: '#53b5e6',
  purple: '#9973C2',
}

export const SLIDE_UP = 1

class LaddaButton extends Component {
  render() {
    let fa = (
      <FontAwesome
        name="cog"
        spin
        style={{textShadow: '0 1px 0 rgba(0, 0, 0, 1.0)'}}
      />
    )
    let classes = this.props.className + ' custom-ladda-button'
    let styles = {
      backgroundColor: colors[this.props['data-color']] || '#666',
    }
    return (
      <button className={classes} onClick={this.props.onClick} style={styles}>
        {(this.props.loading && fa) || this.props.children}
      </button>
    )
  }
}

export default LaddaButton



// WEBPACK FOOTER //
// ./src/components/LaddaButton.jsx